import { useState, useEffect } from 'react';
import { Form, Select, InputNumber, Input, Button, message, Card, Spin } from 'antd';
import { ArrowLeftOutlined, UserAddOutlined } from '@ant-design/icons';
import { getVendorsDetails } from '../../../ApiServices/Apifun';
import { getAllPlans, assignPlan } from './PlansapiFunction';
import { useNavigate } from 'react-router-dom';
const { TextArea } = Input;
const { Option } = Select;

const AssignPlan = ({ onBack }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [vendors, setVendors] = useState([]);
  const [plans, setPlans] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch vendors
        const vendorRes = await getVendorsDetails();
        if (vendorRes.status === 'success') {
          setVendors(vendorRes.data?.vendor || []);
        }

        // Fetch plans
        const planRes = await getAllPlans('?page=1&limit=100&is_active=1');
        if (planRes?.status === 'success') {
          setPlans(planRes?.data?.plans || []);
        }
      } catch (error) {
        message.error('Failed to fetch data');
      }
      setFetchLoading(false);
    };
    fetchData();
  }, []);

  const handleSubmit = async (values) => {

    setLoading(true);
    try {
      const selectedPlan = plans.find(
        (plan) => plan.id === values.plan_id
      );

      const payload = {
        vendor_id: values.vendor_id,
        plan_id: values.plan_id,
        payment_reference:
          selectedPlan?.plan_type === "free"
            ? undefined
            : values.payment_reference || "Not Provided",
        amount_paid: values.amount_paid || 0,
        notes: values.notes || "",
      };
      await assignPlan(payload);
      message.success('Plan assigned successfully!');
      form.resetFields();
      setTimeout(onBack, 1000);
    } catch (error) {
      message.error(error.response?.data?.message || 'Failed to assign plan');
    }
    setLoading(false);
  };

  if (fetchLoading) {
    return (
      <div className="text-center py-20">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="p-6">
      <button
        onClick={onBack}
        className="inline-flex mb-3 items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition-all hover:bg-gray-100 hover:shadow-md active:scale-95"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M15.75 19.5L8.25 12l7.5-7.5"
          />
        </svg>

        Back
      </button>
      <Card title="Assign Plan to Vendor" className="shadow-sm max-w-2xl mx-auto">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
        >
          <Form.Item
            name="vendor_id"
            label="Select Vendor"
            rules={[{ required: true, message: 'Please select a vendor' }]}
          >
            <Select
              placeholder="Choose vendor"
              size="large"
              showSearch
              optionFilterProp="children"
            >
              {vendors.map(vendor => (
                <Option key={vendor.id} value={vendor.id}>
                  {vendor.name} - {vendor.email}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="plan_id"
            label="Select Plan"
            rules={[{ required: true, message: 'Please select a plan' }]}
          >
            <Select
              placeholder="Choose plan"
              size="large"
            >
              {plans.map(plan => (
                <Option key={plan.id} value={plan.id}>
                  {plan.name} - ₹{plan.price} ({plan.duration_days} days)
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="amount_paid"
            label="Amount Paid (₹)"
          >
            <InputNumber
              className="w-full"
              size="large"
              min={0}
              step={0.01}
              prefix="₹"
              placeholder="Leave empty for free plans"
            />
          </Form.Item>

          <Form.Item
            name="payment_reference"
            label="Payment Reference"
          >
            <Input
              placeholder="Payment reference number"
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="notes"
            label="Notes"
          >
            <TextArea rows={3} placeholder="Additional notes" />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            icon={<UserAddOutlined />}
            loading={loading}
            size="large"
            className="w-full"
          >
            Assign Plan
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default AssignPlan;